module.exports = __webpack_public_path__ + "static/media/apartment18.ff0ad6de.jpg";